// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2eedd264","677":"c8a35b22"}[chunkId] + ".chunk.js";
};